var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"search__svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}},[_c('path',{staticClass:"search__path",attrs:{"d":"M8.126,16.257a8.129,8.129,0,1,1,8.132-8.129A8.129,8.129,0,0,1,8.126,16.257Zm0-14.221a6.1,6.1,0,1,0,6.1,6.1,6.1,6.1,0,0,0-6.1-6.1ZM16.558,18l-4.136-4.14,1.432-1.437L18,16.564Z","fill":"#3d3c3c"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84242b46","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/SearchIcon.vue
// module id = null
// module chunks = 